module.exports = __webpack_public_path__ + "img/GPG members on drillfield.190a4d04.png";